const formatNumberZero = (number: number | any): string | any => {
	return number
		? (+number).toLocaleString("sr-RS", {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
		  })
		: 0
}

export default formatNumberZero
